// extracted by extract-css-chunks-webpack-plugin
module.exports = {"business":"business_3a5Sj","nav":"nav_e74xy"};